import { render, staticRenderFns } from "./formerYearsList.vue?vue&type=template&id=525f14e2&scoped=true&"
import script from "./formerYearsList.vue?vue&type=script&lang=js&"
export * from "./formerYearsList.vue?vue&type=script&lang=js&"
import style0 from "./formerYearsList.vue?vue&type=style&index=0&id=525f14e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525f14e2",
  null
  
)

export default component.exports